import { render, staticRenderFns } from "./cate03.vue?vue&type=template&id=621b779d"
import script from "./cate03.vue?vue&type=script&lang=js"
export * from "./cate03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports